import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const NotFoundPage = lazyRoute(() => import('./NotFoundPage'));

/** Catch-all; always last. */
export const notFoundRoutes: RouteObject[] = [{ path: '*', element: <NotFoundPage /> }];
